import { SegmentedControl } from "@dehub/theme";
import { useTranslation } from "react-i18next";
import type { IReference } from "@/models/Reference";
import bz from "@/features/business/business.module.css";

const ALL = "all";

type Props = Readonly<{
  /** The selected branch type code; null means every type. */
  value: string | null;
  types: IReference[];
  onChange: (code: string | null) => void;
}>;

/** "All / Head office / Branch shop" on Mantine's SegmentedControl (real radios, arrow keys). */
export function BranchTypeSwitch({ value, types, onChange }: Props) {
  const { t } = useTranslation("sector");

  return (
    <SegmentedControl
      aria-label={t("typeSwitchLabel")}
      value={value ?? ALL}
      onChange={(next) => onChange(next === ALL ? null : next)}
      classNames={{ root: bz.segmentRoot, indicator: bz.segmentIndicator, label: bz.segmentLabel }}
      data={[{ value: ALL, label: t("typeAll") }, ...types.map((type) => ({ value: type.code, label: type.name }))]}
    />
  );
}
